
import ScrollMagic from "scrollmagic";
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
const controller = new ScrollMagic.Controller;
/**
 * informed
 * @constructor
 */
class IclearCharge {
  constructor() {}
  /**
   * /iclear_charge/
   */
  init() {
    this.iclear1();
    this.iclear2();
    if (window.innerWidth <= 750) {
      this.iclear3sp();
    } else {
      this.iclear3();
    }
    this.iclear4();
    this.iclear5();
  }
  iclear1() {
    // KVのアニメーション
    setTimeout(() => {
      const elements = document.querySelectorAll(".js-kv-slide-in");
      if (elements.length > 0) {
          elements[0].classList.add("is-active");

          if (elements.length > 1) {
              setTimeout(() => {
                  elements[1].classList.add("is-active");
              }, 200); // 0.2秒後に次の要素にクラスを追加
          }
      }
    }, 1000);
  }
  iclear2() {
    // 各タイトルのアニメーション
    const kvTitles = document.querySelectorAll('.js-slide-in');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-active');
      }
      });
    });

    kvTitles.forEach(kvTitle => {
      observer.observe(kvTitle);
    });
  }
  iclear3() {
    // コンセプトのアニメーション
    const imgElements = document.querySelectorAll('.js-img');
    const pointObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          imgElements.forEach(img => {
            img.classList.add('is-show');
          });
          setTimeout(() => {
            const img01 = document.querySelector('.js-img01');
            img01.classList.add('is-show');
            const img02 = document.querySelector('.js-img02');
            img02.classList.add('is-show');

            setTimeout(() => {
              const textBgElements = document.querySelectorAll('.js-textBg');

              textBgElements.forEach((textBg, index) => {
                setTimeout(() => {
                  textBg.classList.add('is-show'); // .js-textBg に is-show を追加

                  // さらに 0.1 秒後に、その中の img に is-show を追加
                  setTimeout(() => {
                    const img = textBg.querySelector('img'); // .js-textBg の中の img を取得
                    if (img) {
                      img.classList.add('is-show');
                    }
                  }, 100);

                }, index * 300); // 0.3秒ごとに順にクラスを付ける
              });
            }, 500); // 0.5秒後に実行
          }, 300);
        }
      });
    });
    const point = document.querySelector('.js-trigger');
    if (point) {
      pointObserver.observe(point);
    }
  }
  iclear3sp() {
    // コンセプトのアニメーションSP
    const textBgElements = document.querySelectorAll(".js-textBgSp");

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const textBg = entry.target;
          textBg.classList.add("is-show"); // .js-textBg に is-show を追加

          setTimeout(() => {
            const img = textBg.querySelector('img');
            if (img) {
              img.classList.add("is-show");
            }
          }, 100);

          observer.unobserve(textBg); // 一度アニメーションを実行したら監視を停止
        }
      });
    }, { threshold: 0.1 }); // 10% 以上見えたら発火

    textBgElements.forEach((element) => {
      observer.observe(element);
    });


    const imgElements = document.querySelectorAll('.js-img');
    const pointObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          imgElements.forEach(img => {
            img.classList.add('is-show');
          });
          setTimeout(() => {
            const img01 = document.querySelector('.js-img01');
            img01.classList.add('is-show');
            const img02 = document.querySelector('.js-img02');
            img02.classList.add('is-show');
          }, 300);
        }
      });
    });
    const point = document.querySelector('.js-triggerSp');
    if (point) {
      pointObserver.observe(point);
    }
  }
  iclear4() {
    // スクロールが達したらふわっと(左から順に)
    const items = document.querySelectorAll(".js-iclearCharge-item01");
    let index = 0;

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // 画面に入ったら、0.5秒ごとに順番に is-show を追加
                setTimeout(() => {
                    entry.target.classList.add("is-show");
                }, index * 500);

                index++;
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1 });

    items.forEach(item => observer.observe(item));
  }
  iclear5() {
    // スクロールが達したらふわっと
    const items = document.querySelectorAll(".js-iclearCharge-item02");
    let index = 0;

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting && entry.target === items[index]) {
                entry.target.classList.add("is-show");
                observer.unobserve(entry.target);
                index++;
            }
        });
    }, { threshold: 0.2 });

    items.forEach(item => observer.observe(item));
  }
};

export default IclearCharge;
